<div class="grid" *ngIf="record.attachs && record.attachs.length > 0">
	<div class="row">
		<div class="column {{currentFileId === record.docPdfId! ? 'active' : ''}}" [style.width]="300 + 'px'">
			<format-data [contentStr]="record.name ?? record.sn" patternStr="E+300" (click)="chooseMain() ">
			</format-data>
		</div>
	</div>
	<div class="row">
		<div class="column text-center" [style.width]="300 + 'px'">
			附件
		</div>
	</div>
	<div class="row" *ngFor="let item of record.attachs; let index = index">
		<div class="column {{currentFileId === item.fileId! ? 'active' : ''}}" [style.width]="300 + 'px'">
			<format-data [contentStr]="item.fileName" patternStr="E+300" (click)="chooseAttach(index) ">
			</format-data>
		</div>
	</div>
</div>

<div class="preview-dialog" [style.minHeight]="height + 'px'" [style.minWidth]="width + 'px'">
	<div class="preview-dialog-header">
		<div class="action">
			<button class="color-primary" nz-button nzType="text" (click)="zoomIn()">
				<span nz-icon nzType="zoom-in" nzTheme="outline"></span>
			</button>
			<button class="color-primary" nz-button nzType="text">
				<span nz-icon nzType="border-outer" nzTheme="outline" (click)="originSize()"></span>
			</button>
			<button class="color-primary" nz-button nzType="text" (click)="zoomOut()">
				<span nz-icon nzType="zoom-out" nzTheme="outline"></span>
			</button>
		</div>
	</div>
	<!-- <div class="preview-dialog-body">
		<pdf-viewer [src]="environment.fileHost + currentFileId + withToken" [render-text]="true" [zoom-scale]="'page-fit'"
			[original-size]="false" style="width: 100%; height: 100%" [zoom]="pdfZoom" [(page)]="pdfPages"
			[c-maps-url]="'/assets/cmaps/'" (pages-initialized)="onPageLoad($event)">
		</pdf-viewer>
	</div> -->


	<div class="preview-dialog-body" [ngSwitch]="currentFileType">
		<img class="preview" *ngSwitchCase="FileType.IMAGE" [src]="environment.fileHost + currentFileId + withToken"
			alt="" style="">
		<!-- <iframe *ngSwitchCase="FilePreviewType.PDF" [src]="data.fileList[index] | safeResourceUrl">
			</iframe> -->


		<pdf-viewer *ngSwitchCase="FileType.PDF" [src]="environment.fileHost + currentFileId + withToken"
			[c-maps-url]="'/assets/cmaps/'" [render-text]="true" [zoom-scale]="'page-fit'" [original-size]="false"
			style="width: 100%; height: 100%" [zoom]="pdfZoom" [(page)]="pdfPages"
			(pages-initialized)="onPageLoad($event)">
		</pdf-viewer>

		<p *ngSwitchDefault>
			暂时无法预览这个格式的文件
		</p>

	</div>
</div>
<div class="dialog">
	<div class="dialog-header">补充信息</div>
	<div class="dialog-body">
		<div class="grid">
			<div class="row" *ngIf="!headerMap['sectionId']?.hidden && !hasZhusong">
				<div class="column background-page text-right" [style.width]="110 + 'px'">
					施工标段
				</div>
				<div class="column" [style.width]="480 + 'px'">
					<select [(ngModel)]="record.sectionId">
						<option [value]="undefined" disabled>选择标段</option>
						<option *ngFor="let item of consSectionList" [value]="item.id">{{item.name}}</option>
					</select>
				</div>
			</div>
			<div class="row" *ngIf="!headerMap['superviseSectionId']?.hidden && !hasZhusong">
				<div class="column background-page text-right" [style.width]="110 + 'px'">
					监理标段
				</div>
				<div class="column" [style.width]="480 + 'px'">
					<select [(ngModel)]="record.superviseSectionId">
						<option [value]="undefined" disabled>选择标段</option>
						<option *ngFor="let item of supSectionList" [value]="item.id">{{item.name}}</option>
					</select>
				</div>
			</div>

			<div class="row" *ngIf="!headerMap['constructionOrgName']?.hidden">
				<div class="column background-page text-right" [style.width]="110 + 'px'">
					施工单位
				</div>
				<div class="column" [style.width]="480 + 'px'">
					<select [(ngModel)]="record.constructionOrgName">
						<option [value]="undefined" disabled>选择施工单位</option>
						<option *ngFor="let item of consOrgNameList" [value]="item">{{item}}</option>
					</select>
				</div>
			</div>

			<div class="row" *ngIf="!headerMap['supervisionOrgName']?.hidden">
				<div class="column background-page text-right" [style.width]="110 + 'px'">
					监理单位
				</div>
				<div class="column " [style.width]="480 + 'px'">
					<select [(ngModel)]="record.supervisionOrgName">
						<option [value]="undefined" disabled>选择监理单位</option>
						<option *ngFor="let item of supOrgNameList" [value]="item">{{item}}</option>
					</select>
				</div>
			</div>

			<div class="row" *ngFor="let header of headerList">
				<div class="column background-page text-right" [style.width]="110 + 'px'">
					<span *ngIf="header.formItemId && requireMap[header.formItemId]" class="color-danger">*</span>
					{{header.headerName}}
				</div>
				<div *ngIf="header.headerName !== '归属年月' && header.headerName !== '主送单位' && header.headerName !== '上级检查单位'"
					class="column {{header.formItemId && requireMap[header.formItemId] ? 'validate' : ''}}"
					[style.width]="480 + 'px'">
					<input *ngIf="header.format === FormHeaderFormat.TEXT && header.search !== FormHeaderSearch.ENUM"
						type="text" [disabled]="header.fixedParamValue === '-'" placeholder="输入{{header.headerName}}"
						[(ngModel)]="record[header.fieldName!]">
					<input *ngIf="header.format === FormHeaderFormat.NUMBER" type="text"
						[disabled]="header.fixedParamValue === '-'" placeholder="输入{{header.headerName}}"
						[(ngModel)]="record[header.fieldName!]" appDigitalFormat>
					<input *ngIf="header.format === FormHeaderFormat.MONEY" type="text"
						[disabled]="header.fixedParamValue === '-'" placeholder="输入{{header.headerName}}"
						[(ngModel)]="record[header.fieldName!]" appFloatFormat [precision]="2">
					<select *ngIf="header.format === FormHeaderFormat.TEXT && header.search === FormHeaderSearch.ENUM"
						[(ngModel)]="record[header.fieldName!]"
						class="{{header.formItemId && requireMap[header.formItemId] && !record[header.fieldName!] ? 'validate' : ''}}">
						<option *ngFor="let item of optionMap[header.fieldName!]" [value]="item.value">
							{{item.label}}
						</option>
					</select>
					<nz-date-picker *ngIf="header.format === FormHeaderFormat.DATE"
						[nzDisabled]="header.fixedParamValue === '-'" [(ngModel)]="record[header.fieldName!]"
						[nzSuffixIcon]="''" nzPlaceHolder="输入{{header.headerName}}" nzFormat="yyyy-MM-dd">
					</nz-date-picker>
				</div>
				<div *ngIf="header.headerName === '主送单位'"
					class="column {{record.status === WorkReportStatus.FINISH ? 'background-module' : ''}}"
					[style.width]="480 + 'px'">
					<!-- 三桥特殊处理 -->
					<select [(ngModel)]="zhusongOrgId" *ngIf="record.status !== WorkReportStatus.FINISH"
						(ngModelChange)="onZhusongChange()"
						class="{{header.formItemId && requireMap[header.formItemId] && !record[header.fieldName!] ? 'validate' : ''}}">
						<option [value]="''" disabled>选择主送单位</option>
						<option *ngFor="let item of prOrgList" [value]="item.value"> {{item.label}}
						</option>
					</select>
					<format-data *ngIf="record.status === WorkReportStatus.FINISH"
						[contentStr]="record[header.fieldName!]" patternStr="E+470">
					</format-data>
					<!-- <nz-select *ngIf="record.status !== WorkReportStatus.FINISH" [(ngModel)]="zhusongOrgList"
						nzPlaceHolder="选择主送单位" [nzAllowClear]="true" [nzShowSearch]="true" nzMode="multiple">
						<nz-option *ngFor="let org of prOrgList" [nzLabel]="org.label" [nzValue]="org.value">
						</nz-option>
					</nz-select> -->
				</div>
				<div *ngIf="header.headerName === '上级检查单位'" class="column" [style.width]="480 + 'px'">
					<!-- 三桥特殊处理 -->
					<select [(ngModel)]="record[header.fieldName!]"
						class="{{header.formItemId && requireMap[header.formItemId] && !record[header.fieldName!] ? 'validate' : ''}}">
						<option [value]="undefined" disabled>选择检查单位</option>
						<option [value]="'杭州市交通运输行政执法队'">杭州市交通运输行政执法队</option>
						<option [value]="'浙江省交通工程管理中心'">浙江省交通工程管理中心</option>
						<option [value]="'杭州市交通运输行政执法队，浙江省交通工程管理中心'">杭州市交通运输行政执法队，浙江省交通工程管理中心</option>
					</select>
				</div>
				<div *ngIf="header.headerName === '归属年月'" class="column" [style.width]="480 + 'px'">
					<nz-date-picker [nzMode]="'month'" [(ngModel)]="record[header.fieldName!]" [nzSuffixIcon]="''"
						[nzDisabled]="header.fixedParamValue === '-'" nzPlaceHolder="输入{{header.headerName}}"
						nzFormat="yyyy-MM">
					</nz-date-picker>
				</div>
			</div>
		</div>
	</div>
	<div class="dialog-footer">
		<button nz-button nzType="default" (click)="cancel()">取消</button>
		<button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
	</div>
</div>